<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ثبت خرید</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group v-show="hasPermission('write_created_at_in_mini_orders') ? true : false" class="col-md-6" label="زمان ثبت">
            <date-picker
              type="datetime"
              v-model="created_at"
              :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'"
            />
          </b-form-group>
          <b-form-group label="انتخاب مشتری">
            <div class="d-flex col-md-6 mb-3" style="gap: 0.5rem">
              <b-form-input  
                @keypress.enter.prevent="requestCustomer"  
                v-model="customerMobile"  
                :disabled="disabled || customerInfo"  
                @input="requestCustomer"  
                type="text"  
                autofocus  
              />
              <button
                @click="clearCustomer"
                v-if="customerInfo"
                class="btn btn-danger"
              >
                لغو مشتری
              </button>
            </div>
            <template v-if="customerInfo">
              <div v-if="customerInfo.customer" class="row">
                <div
                  v-for="i in [['حضوری', 'physical']]"
                  :key="i[1]"
                  class="col-6 d-flex justify-content-between px-3"
                >
                  <div>
                    شارژ کیف پول:
                    <span v-if="customerInfo.customer" class="font-weight-bold">{{
                      customerInfo.customer.wallet.balance | price
                    }} تومان</span>
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span
                    >
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 font-weight-bold" v-else>مشتری جدید</div>
            </template>
          </b-form-group>
          <div class="row">
            <b-form-group class="col-md-6" label="نام">
              <b-form-input
                type="text"
                v-model="firstName"
              />
            </b-form-group>
            <b-form-group class="col-md-6" label="نام خانوادگی">
              <b-form-input
                type="text"
                v-model="lastName"
              />
            </b-form-group>
          </div>
          <b-form-group class="col-6">
            <label class="" for="products">
              فروشنده <i class="text-danger">*</i></label
            >
            <div id="selectSeller">
              <button
                v-for="(seller, index) in sellers"
                :key="index"
                class="sellerBtn"
                :class="{ active: selectedSellerId == seller.id }"
                type="button"
                @click="selectedSellerFunc(seller)"
              >
                {{ seller.label }}
              </button>
            </div>
          </b-form-group>
          <b-form-group label="انتخاب محصول">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input
                autocomplete="off"
                ref="productSku"
                v-model="productSku"
                :disabled="disabled"
                @keypress.prevent.enter="requestProduct"
                type="text"
              />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox
                  id="refund_checkbox"
                  type="checkbox"
                  :disabled="disabled"
                  v-model="refund"
                />
              </div>
            </div>
          </b-form-group>
          <b-form-group label="جستجوی محصول">
            <ProductSearch
              ref="productSearch"
              :selectable="true"
              class="row"
              :show-label="false"
              @selectVariety="selectVariety"
            />
          </b-form-group>
          <div
            v-for="i in ['varieties', 'refund_varieties']"
            v-if="$data[i] != ''"
          >
            <template>
              <h4 class="table-title">
                <template v-if="i === 'varieties'">فروش</template>
                <template v-else>مرجوع</template>
              </h4>
            </template>
            <b-table
              class="mt-3 admin-order"
              :class="$data[i]"
              hover
              bordered
              responsive
              :items="$data[i]"
              :fields="fields"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(image)="data" class="text-center">
                <div class="order-product-img">
                  <a :href="getImage(data.item)">
                    <img class="w-100 h-100" :src="getImage(data.item)" />
                  </a>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <span style="width: 300px">
                  <span style="line-height: 2">{{
                    data.item.product.title
                  }}</span>
                  <span v-if="data.item.color || data.item.attributes != ''">
                    <span> | </span>
                    <span v-if="data.item.color">
                      رنگ : {{ data.item.color.name }}
                      {{ data.item.attributes != "" ? " | " : "" }}
                    </span>
                    <span v-if="data.item.attributes != ''">
                      <span
                        v-for="(attr, index) in data.item.attributes"
                        :key="index"
                      >
                        {{ attr.label + ": " + attr.pivot.value }}
                        {{
                          index != data.item.attributes.length - 1 ? " | " : ""
                        }}
                      </span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-slot:cell(quantity)="data">
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="decrement(data.item)"
                  :disabled="data.item.quantity == 1 || disabled ? true : false"
                >
                  <DashSvg />
                </button>
                <span class="px-2">{{ data.item.quantity }}</span>
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="increment(data.item)"
                  :disabled="disabled"
                >
                  <PlusSvg />
                </button>
              </template>
              <template v-slot:cell(amount)="data">
                <b-form-input
                v-if="i !== 'varieties'"
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.price | priceinput"
                  @input="
                    (value) => {
                      data.item.price =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                >
                </b-form-input>
                <span v-else>
                  {{ data.item.price | price }}
                </span>
              </template>
              <template v-slot:cell(discount_amount)="data">
                <span v-if="data.item.final_price.discount_price">{{
                  data.item.final_price.discount_price | price
                }}</span>
                <span v-else>ندارد</span>
              </template>
              <template v-slot:cell(flash)="data">
                {{
                  data.item.product && data.item.product.active_flash != ""
                    ? data.item.product.active_flash[0].title
                    : "ندارد"
                }}
              </template>
              <template v-slot:cell(total_price)="data">
                <span v-if="data.item.final_price.amount != 0">
                  <!-- <span>{{ (data.item.price * data.item.quantity) | price }}</span>
                  <span>{{ (data.item.final_price.discount_price * data.item.quantity) | price }}</span>
                  <br> -->
                  <span v-if="i !== 'varieties'">{{ (data.item.price * data.item.quantity) - (data.item.final_price.discount_price * data.item.quantity) | price }}</span>
                  <span v-else>{{ (data.item.final_price.amount * data.item.quantity) | price }}</span>
                </span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(seller_id)="data">
                <b-button @click="sellerModalHandler(data.item.id)">
                  <span>
                    {{
                      seller_ids[data.item.id] && seller_ids[data.item.id].label
                        ? seller_ids[data.item.id].label
                        : "انتخاب نشده"
                    }}
                  </span>
                  <i class="fa fa-angle-down"></i>
                </b-button>
              </template>
              <template v-slot:cell(delete)="data">
                <a
                  class="action-btns1 pt-1 px-2"
                  @click="deleteItem(data.item, i)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <template v-if="varieties != '' || refund_varieties != ''">
            <div
              class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
            >
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                <span class="px-3 py-2"> {{ total | price }} تومان </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> فاکتور باز : </span>
                <div class="px-3 py-2">
                  <input type="checkbox" v-model="isOpen">
                </div>
              </div>
              <!-- <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> تخفیف : </span>
                <span class="px-3 py-2">
                  <b-form-input
                    style="width: 80px"
                    :value="discountAmount | priceinput"
                    @input="
                      (value) => {
                        discountAmount =
                          value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    "
                  />
                </span>
              </div> -->

              <!-- <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> کدتخفیف دارد؟ </span>
                <form
                  id="coupenCode"
                  @submit.prevent="sendCoupen()"
                  v-if="!coupenPrice"
                >
                  <input type="text" placeholder="کد تخفیف" v-model="coupen" />
                  <input
                    type="submit"
                    value="ثبت"
                    :class="{ disableCoupen: disableCoupen }"
                  />
                </form>
                <p id="danger" v-else>
                  <span>
                    {{ coupenPrice | priceinput }}
                  </span>
                  <span> تومان </span>
                  <i @click="clearCoupon()" class="fa fa-trash text-danger"></i>
                </p>
              </div> -->
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">تخفیف (تومان):</span>
                <b-form-input
                  style="width: 130px"
                  :value="discountAmount | priceinput"
                  @input="handleDiscountChange"
                />
                <!-- <input type="text" placeholder="کد تخفیف" style="width: 140px" 
                :value="priceinput" class="form-control" v-model="discountAmount" 
                @input="
                    (value) => {
                      priceinput =
                      value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                    "
                /> -->
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ کارت به کارت (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cardByCard_amount | priceinput"
                  @input="
                    (value) => {
                      cardByCard_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ پرداخت نقدی (تومان):
                </span>
                <b-form-input
                  style="width: 130px"
                  :value="cash_amount | priceinput"
                  @input="
                    (value) => {
                      cash_amount =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                />
              </div>
              <div
                v-if="
                  customerInfo &&
                  customerInfo.customer &&
                  customerInfo.customer.wallet &&
                  customerInfo.customer.wallet.balance > 0
                "
                class="d-md-flex justify-content-between"
              >
              <span class="px-3 py-2 font-bold">  
                میزان کسر از کیف پول (تومان):  
              </span>  
              <b-form-input
                  style="width: 130px"
                  :value="walletB | priceinput"
                  @input="
                    (value) => {
                      walletB =
                        value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "                 
                />
              <!-- <span class="px-3 py-2">  
                {{ customerInfo.customer.wallet.balance > total ? total : customerInfo.customer.wallet.balance | price }} تومان  
              </span>   -->
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> پرداخت نهایی (ریال): </span>
                <span
                  class="px-3 py-2"
                  :class="{
                    'text-success': totalPrice >= 0,
                    'text-danger': totalPrice < 0,
                  }"
                >
                  {{ (totalPrice * 10) | price }} ریال
                </span>
              </div>
            </div>
            <div class="row mt-4">
              <b-form-group
                class="col-md-6"
                label="یادداشت"
                :label-for="'description'"
              >
                <b-form-textarea
                  id="description"
                  v-model="description"
                  placeholder="یادداشت"
                  :required="isDiscountFilled"
                />
              </b-form-group>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button
                type="submit "
                :class="{ reqDiasableStyle: !reqDiasableStyle }"
                class="btn btn-success"
              >
                ثبت سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')"
                >X</b-button
              >
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button
                  v-for="(seller, index) in sellers"
                  :key="index"
                  class="sellerBtn"
                  type="button"
                  @click="selectedSellerForVariety(seller)"
                >
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopCreate",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      disabled: false,
      refund: false,
      selectedSeller: null,
      selectedSellerId: null,
      seller_ids: {},
      showModal: false,
      created_at: null,
      discountAmount: 0,
      cardByCard_amount: null,
      cash_amount: null,
      description: null,
      sendCoupenStatus: false,
      sellers: [],
      isOpen: 0,
      selectedVarietyId: null,
      productSku: "",
      reqDiasableStyle: true,
      customerMobile: "",
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "barcode",
          label: "بارکد",
        },
        {
          key: "image",
          label: "تصویر",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "amount",
          label: "قیمت واحد (تومان)",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
        {
          key: "discount_amount",
          label: "تخفیف واحد (تومان)",
        },
        {
          key: "seller_id",
          label: "فروشنده",
        },
        {
          key: "flash",
          label: "کمپین",
        },
        {
          key: "total_price",
          label: "قیمت نهایی (تومان)",
        },
        {
          key: "delete",
          label: "حذف",
        },
      ],
      varieties: [],
      refund_varieties: [],
      firstName: '',
      lastName: '',
      customerInfo: null,
      flag: true,
      coupenPrice: null,
      walletB:null,
      coupen: null,
      disableCoupen: false,
    };
  },
  computed: {
    isDiscountFilled() {
      if (this.discountAmount > 0) {
        return true;
      } else if(this.totalPrice <= 0){
        return true;
      } else {
        return false;
      }
    },
    total() {  
      const totalVarieties = this.varieties.reduce((a, b) => a + (b.price * b.quantity), 0);  
      const totalDiscount = this.varieties.reduce((a, b) => a + (b.final_price.discount_price * b.quantity), 0);  
      const totalRefunds = this.refund_varieties.reduce((a, b) => a + (b.price * b.quantity) - (b.final_price.discount_price * b.quantity), 0);  
      
      return totalVarieties - totalDiscount - totalRefunds;  
    },  
    totalPrice() {  
      let totalAmount = this.total;  
      let walletBalance = 0;  

      if (this.customerInfo && this.customerInfo.customer && this.customerInfo.customer.wallet) {  
          walletBalance = this.customerInfo.customer.wallet.balance;  
          if (this.walletB > walletBalance) {  
              this.walletB = 0; 
          }  
      }  

      if (this.discountAmount > 0) {  
          totalAmount -= this.discountAmount;  
      }  
      if (this.cardByCard_amount > 0) {  
          totalAmount -= this.cardByCard_amount;  
      }  
      if (this.cash_amount > 0) {  
          totalAmount -= this.cash_amount;  
      }  
      if (this.walletB > 0 && this.walletB < totalAmount) {  
          totalAmount -= this.walletB;  
      } else if (this.walletB >= totalAmount && this.walletB > 0) {  
          totalAmount = 0; 
      }  

      return totalAmount;  
    }  
  },
  mounted() {
    this.listenForKeyPress();
  },
  methods: {
    async getSellers() {
      const response = await this.$axios.get("admin/sellers?all=1");
      this.sellers = response.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
    },
    checkCoupon() {
      if (this.coupenPrice) {
        this.coupenPrice = null;
        this.$root.notify(
          "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
          "warning"
        );
      }
    },
    clearCoupon() {
      this.coupenPrice = null;
      this.coupen = "";
    },
    selectedSellerForVariety(seller) {
      this.seller_ids[this.selectedVarietyId] = {
        label: seller.label,
        id: seller.id,
      };
      this.closeModal("close");
    },
    selectVariety(variety) {
      this.addVariety(variety);
    },
    async sendCoupen() {
      this.disableCoupen = true;
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      try {
        let fd = new FormData();
        fd.append("code", this.coupen);
        let reqBody = {
          mobile: this.customerMobile,
          discount_amount: this.discountAmount,
          first_name: this.firstName,
          last_name: this.lastName,
          description: this.description,
          from_wallet_amount: this.from_wallet_amount,
          varieties,
          refund_varieties,
        };
        if (this.coupen) {
          reqBody.coupon_code = this.coupen;
        }
        const response = await this.$axios.post("admin/coupon/verify", reqBody);

        this.coupenPrice = response.data.data.discount.discount;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disableCoupen = false;
      }
    },
    listenForKeyPress() {
      document.removeEventListener("keyup", this.onKeyPress);
      document.addEventListener("keyup", this.onKeyPress);
    },
    onKeyPress(e) {
    },
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            sku: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify(
            "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
            "warning"
          );
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {  
            this.$refs.productSku.focus();  
        });  
      }
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";
      const alreadyAdded = this[mode].find((v) => {
        return v.id == variety.id;
      });
      if (alreadyAdded) {
        alreadyAdded.quantity++;
        this.$root.notify(
          "به تعداد محصول اضافه شد: " + alreadyAdded.quantity,
          "success"
        );
      } else {
        variety.quantity = 1;
        this[mode].push(variety);
        this.seller_ids[variety.id] = this.selectedSeller
          ? { label: this.selectedSeller.label, id: this.selectedSeller.id }
          : {};
      }
    },
    calculatedPrice(amount, discount) {  
      return amount + discount;  
    },  
    formattedPriceInput(amount, discount) {  
      const price = discount ? this.calculatedPrice(amount, discount) : amount;  
      return price ? price.toLocaleString('fa-IR') : '';  
    },  
    updatePrice(data, event) {  
      const value = event.target.value;  
      const cleanedValue = value !== '' ? +value.replace(/\D/g, '').replace(/,/g, '') : '';  
      this.$emit('update-price', { item: data.item, amount: cleanedValue });  
    },  
    selectedSellerFunc(seller) {
      this.selectedSellerId = seller.id;
      this.selectedSeller = seller;
    },
    getImage(variety) {
      if (variety.images != "") {
        return variety.images[0].url;
      }
      if (variety.product.images != "") {
        return variety.product.images[0].url;
      }
      return null;
    },
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      this.checkCoupon();
    },
    increment(variety) {
      variety.quantity++;
      this.checkCoupon();
    },
    handleDiscountChange(value) {
      this.discountAmount = value !== "" ? +value.replace(/\D/g, "") : "";
    },
    deleteItem(variety, mode) {
      this[mode] = this[mode].filter((v) => {
        return v.id !== variety.id;
      });
      this.checkCoupon();
    },
    async requestCustomer(mobile) {
      if (mobile.length !== 11) return;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/mini_orders/customer-search",
          {
            params: {
              mobile,
            },
          }
        );
        this.disabled = false;
        const data = response.data.data;
        data.from_wallet_amount = data.from_wallet_amount || 0;
        this.customerInfo = data;
        this.walletB=this.customerInfo.customer?.wallet.balance;

        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      }
    },
    clearCustomer() {
      this.customerInfo = null;
      this.customerMobile = "";
    },
    async submit() {
      if (!this.validate()) {
        return;
      }
      let fd = new FormData();
      if (this.created_at) {
        fd.append("created_at", this.created_at);
      }
      fd.append(
        "cardByCard_amount",
        this.cardByCard_amount ? this.cardByCard_amount : 0
      );

      fd.append("mobile", this.customerMobile);
      fd.append("first_name", this.firstName);
      fd.append("last_name", this.lastName);
      fd.append("cash_amount", this.cash_amount ? this.cash_amount : 0);
      fd.append(
        "discount_amount",
        Number(this.discountAmount) +
          Number(this.coupenPrice ? this.coupenPrice : 0)
      );
      fd.append("description", this.description);
      if (this.walletB) {
        fd.append("from_wallet_amount", this.walletB);
      }
      if (this.isOpen == true) {
        fd.append("is_open",1);
      }else{
        fd.append("is_open",this.isOpen);
      }
      if (this.coupen) fd.append("coupon_code", this.coupen);
      fd.append("sendCouponIsActive", this.sendCoupenStatus ? 1 : 0);
      this.varieties.forEach((item, index) => {
        fd.append(
          `varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
        );
        fd.append(`varieties[${index}][id]`, item.id);
        fd.append(`varieties[${index}][quantity]`, item.quantity);
        fd.append(`varieties[${index}][amount]`,item.final_price.amount);
        if (item.final_price.discount_price) {
          fd.append(`varieties[${index}][discount_amount]`,item.final_price.discount_price);
        }
        if (item.final_price.discount_price) {
          fd.append(`varieties[${index}][real_amount]`, item.price);
        }
      });
      this.refund_varieties.forEach((item, index) => {
        console.log(item);
        fd.append(
          `refund_varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
        );
        fd.append(`refund_varieties[${index}][id]`, item.id);
        fd.append(`refund_varieties[${index}][quantity]`, item.quantity);
        fd.append(`refund_varieties[${index}][amount]`,item.price);
        if (item.final_price) {
          fd.append(`refund_varieties[${index}][real_amount]`, item.final_price.amount + item.final_price.discount_price );
        }
      });
      try {
        this.reqDiasableStyle = false;
        this.disabled = true;
        const response = await this.$axios.post("admin/mini_orders", fd);

        const miniOrder = response.data.data.mini_order;
        console.log(miniOrder);
        this.$root.notify(response.data.message, "success");
        this.$router.push(`/admin/shop/orders/${miniOrder.id}?print=1`);
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
      }
    },
    validate() {
      if (
        (!this.varieties || !this.varieties.length) &&
        !this.refund_varieties &&
        !this.refund_varieties.length
      ) {
        this.$root.warningNotify("حداقل انتخاب یک تنوع الزامی است");
        return false;
      }
      return true;
    },
  },
  watch: {
    discountAmount(newValue) {
      this.checkCoupon();
    },
  },
  created() {
    this.getSellers();
  },
};
</script>

<style scoped>
.reqDiasableStyle {
  pointer-events: none;
  opacity: 0.5;
}
.order-product-img {
  max-width: 50px;
  margin: auto;
}

.table-title {
  font-weight: bold;
}
</style>
<style>
.card.little.info {
  background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
}

.card.little.online {
  background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
}

.card.little.physical {
  background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
}

.card.little .card-header {
  font-weight: bold;
}
form#coupenCode input[type="submit"] {
  background-color: #1d99ff;
  color: white;
}

form#coupenCode input {
  padding: 4px 8px;
  border: 2px solid #1d99ff;
}
.disableCoupen {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
button#sendCoupen {
  display: flex;
  align-items: center;
  gap: 8px;
}
button#sendCoupen input {
  transform: scale(1.5);
}
.btnprimary {
  color: #fff !important;
  background-color: #0075ff;
  border-color: #3366ff;
}
.btnprimary:hover {
  background-color: #0256b8;
}
.btnprimary:hover input[type="checkbox"] {
  accent-color: #0256b8;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}
div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}
div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
  overflow: visible;
}
div#selectSellerModal {
  position: fixed;
  inset: 0;
  background: #11221194;
  z-index: 10000;
}
div#selectSellerModalContainer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
</style>
